import React from "react";
import styled from "styled-components";
import WheelComponent from "../../../components/WheelComponent";
import { ASSETS } from "../../../utils/config";
import { WheelThumb } from "../styles";
import { trimUrl } from "./captureWheelPicker";

const SIZE_PX = 60;

// createPie paints the orange iYuga logo when url is empty. D3 thumbs use a
// transparent center; the overlay below is the one center image (portrait or
// iYuga) so we never stack two logos.
const CLEAR_CENTER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const PickerThumb = styled(WheelThumb)`
  position: relative;
  background-color: transparent;

  img[data-testid="picker-iyuga-center"] {
    position: absolute;
    width: 60%;
    height: 60%;
    top: 20%;
    left: 20%;
    object-fit: cover;
    border-radius: 50%;
    pointer-events: none;
  }
`;

const D3Thumb = ({ wheel }) => {
  const chartData = Array.isArray(wheel?.chartData) ? wheel.chartData : [];
  return (
    <WheelComponent
      width={`${SIZE_PX}px`}
      height={`${SIZE_PX}px`}
      config={{ isSmallView: true, showTooltips: false }}
      userData={{ id: wheel?.id, url: CLEAR_CENTER }}
      maxSelectedArcs={0}
      arcThickness={-2}
      chartData={chartData}
      margin={1}
      setChartData={() => {}}
      containerDivStyle={{
        width: `${SIZE_PX}px`,
        height: `${SIZE_PX}px`,
        overflow: "hidden",
      }}
    />
  );
};

/**
 * Attach/Detach picker row thumb — always live D3 (WheelComponent).
 * `wheel_preview` PNGs are ignored here so every row matches the D3 path.
 */
const PickerWheelThumb = ({ wheel }) => {
  const portraitUrl = trimUrl(wheel?.portrait);
  // D3 path: wheel_image when the API sent one, otherwise iYuga. segment_color
  // being null must not hide this — those wheels still need a center.
  const centerUrl = portraitUrl || ASSETS.wheelLogoFallback;

  return (
    <PickerThumb
      data-testid="wheel-thumb"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <D3Thumb wheel={wheel} />
      <img data-testid="picker-iyuga-center" src={centerUrl} alt="" />
    </PickerThumb>
  );
};

export default PickerWheelThumb;
